import React from 'react';
import { useNavigate } from 'react-router-dom';
import './TestCard.css';

interface TestCardProps {
    id: string;
    title: string;
    description: string;
    duration: string;
    icon?: string;
    imageUrl?: string;
}

const TestCard: React.FC<TestCardProps> = ({ id, title, description, duration, icon, imageUrl }) => {
    const navigate = useNavigate();
    const [imageError, setImageError] = React.useState(false);

    const handleClick = () => {
        navigate(`/materials/test/${id}`);
    };

    const showImage = imageUrl && !imageError;

    return (
        <div className="test-card" onClick={handleClick}>
            <div className="test-card-icon-container">
                {showImage ? (
                    <img
                        src={imageUrl}
                        alt={title}
                        className="test-card-image"
                        onError={() => setImageError(true)}
                    />
                ) : (
                    <div className="test-card-icon">{icon}</div>
                )}
            </div>
            <div className="test-card-content">
                <h3 className="test-card-title">{title}</h3>
                <p className="test-card-description">{description}</p>
                <div className="test-card-footer">
                    <span className="test-card-duration">⏱ {duration}</span>
                    <button className="test-card-button">Начать тест</button>
                </div>
            </div>
        </div>
    );
};

export default TestCard;
